/* unplugin-vue-components disabled */import script from "./Support.vue?vue&type=script&setup=true&lang=ts"
export * from "./Support.vue?vue&type=script&setup=true&lang=ts"

import "./Support.vue?vue&type=style&index=0&id=58446345&scoped=true&lang=less"

import exportComponent from "/Users/crossle/Code/github.com/OneMornin/mornin.one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58446345"]])

export default __exports__